module.exports = __webpack_public_path__ + "img/unit5 - 副本.818a5010.jpg";